<div class="row">
    <div [class]="fullScreen ? 'col-12' : 'col-4'"
         style="border: 1px solid whitesmoke; background-color: white"
    >
        <div class="p-1"
             style="border-bottom: 1px solid black; cursor: default"
        >
            <strong>{{ 'USER_PROFILE.TEXT.DOC.FILES' | translate }}</strong>
            <i (click)="fullScreen = !fullScreen"
               *ngIf="!!selectedCollection"
               class="bi bi-arrows-fullscreen float-end px-2"
               style="cursor: pointer; border-left: 1px solid black"
            ></i>
        </div>
        <div class="dash-list"
             style="margin-bottom: unset">
            <div *ngIf="!fullScreen">
                <div *ngIf="!files">
                    <small><i>{{ 'USER_PROFILE.TEXT.DOC.SELECT_COLLECTION' | translate }}
                        <i class="bi bi-arrow-right-short"></i></i></small>
                </div>
                <div *ngIf="files && !files.length"
                     class="alert alert-info">
                    <small><i>{{ 'EMPTY_LISTS.COLLECTION' | translate }}</i></small>
                </div>
                <div *ngFor="let file of files"
                     class="division-item">
                    <div class="division-item item-head flex-display align-items-center justify-content-between">
                        <div class="flex-display align-items-center">
                            <i class="icon-file me-1"
                               ngbTooltip="{{ 'USER_PROFILE.TEXT.DOC.FILE' | translate }}"
                            ></i>
                            <span (click)="selectFile(file.file, docModal)"
                                  class="text-primary pointer"
                            >
                                    {{ file.file.name }} <br>
                                <small class="text-info">{{ file.file.updated_at | date:'HH:mm dd.MM.yyyy' }}</small>
                            </span>
                        </div>
                        <i (click)="openPermissionsTemplate(file.file, rightsModal, file.rights)"
                           class="bi bi-gear-fill pointer"
                        ></i>
                    </div>
                </div>

                <app-component-pagination
                        (page)="selectCollection(selectedCollection, $event)"
                        *ngIf="files && files.length"
                        [pagination]="filesPagination"
                ></app-component-pagination>
            </div>
            <div *ngIf="fullScreen">
                <app-component-folder-and-file-table
                        (eventClick)="selectFile($event, docModal)"
                        [data]="dataForTable"
                        [showBackButton]="false"
                ></app-component-folder-and-file-table>
            </div>
        </div>
    </div>

    <div *ngIf="!fullScreen"
         class="col-4"
         style="border: 1px solid whitesmoke; background-color: white"
    >
        <div class="p-1"
             style="border-bottom: 1px solid black; cursor: default"
        >
            <strong>{{ 'USER_PROFILE.TEXT.DOC.COLLECTIONS' | translate }}</strong>
        </div>
        <div>
            <div class="dash-list"
                 style="margin-bottom: unset">
                <div *ngIf="!collections">
                    <small><i>{{ 'USER_PROFILE.TEXT.DOC.SELECT_FOLDER' | translate }} <i
                            class="bi bi-arrow-right-short"></i></i></small>
                </div>
                <div *ngIf="collections && !collections.length"
                     class="alert alert-info">
                    <small><i>{{ 'EMPTY_LISTS.FOLDER' | translate }}</i></small>
                </div>
                <div *ngFor="let collection of collections"
                     class="division-item">
                    <div [class.selected]="selectedCollection && (selectedCollection.id === collection.collection.id)"
                         class="division-item item-head flex-display align-items-center justify-content-between">
                        <div class="flex-display align-items-center">
                            <i [class]="collection.collection.type_str === 'collection' ? 'icon-bookmarks me-1' : 'bi bi-folder2 docs-icon me-1'"
                               ngbTooltip="{{ 'USER_PROFILE.TEXT.DOC.COLLECTION' | translate }}"></i>
                            <span (click)="selectCollection(collection.collection)"
                                  class="text-primary pointer">
                                    {{ collection.collection.name }} <br>
                                <small class="text-info">{{ collection.collection.updated_at | date:'HH:mm dd.MM.yyyy' }}</small>
                            </span>
                        </div>
                        <i (click)="openPermissionsTemplate(collection.collection ?? collection.folder, rightsModal, collection.rights)"
                           class="bi bi-gear-fill pointer"
                        ></i>
                    </div>
                </div>
                <app-component-pagination
                        (page)="selectFolder(selectedFolder, $event)"
                        *ngIf="collections && collections.length"
                        [pagination]="collectionsPagination"
                ></app-component-pagination>
            </div>
        </div>
    </div>

    <div *ngIf="!fullScreen"
         class="col-4"
         style="border: 1px solid whitesmoke; background-color: white"
    >
        <div class="p-1"
             style="border-bottom: 1px solid black; cursor: default"
        >
            <strong>{{ 'USER_PROFILE.TEXT.DOC.NAVIGATOR' | translate }}</strong>
        </div>
        <div>
            <div *ngIf="foldersTree"
                 class="dash-list"
                 style="margin-bottom: unset">
                <div *ngIf="!foldersTree.length"
                     class="alert alert-info">
                    <small><i>{{ 'EMPTY_LISTS.NAVIGATOR' | translate }}</i></small>
                </div>
                <div *ngFor="let folder of foldersTree"
                     class="division-item">
                    <ng-container
                            *ngTemplateOutlet="folderItem; context: {folder: folder}"></ng-container>
                </div>

                <ng-template #folderItem
                             let-folder="folder">
                    <div [class.selected]="selectedFolder && (selectedFolder.id === folder.folder.id)"
                         class="division-item item-head flex-display align-items-center justify-content-between"
                    >
                        <div class="flex-display align-items-center">
                            <div style="width: 26px">
                                <i (click)="foldersSlider[folder.folder.id] = !foldersSlider[folder.folder.id]"
                                   *ngIf="folder.children && folder.children.length"
                                   [class]="foldersSlider[folder.folder.id] ? 'bi bi-caret-down me-5px pointer' : 'bi bi-caret-right me-5px pointer'"
                                ></i>
                            </div>
                            <i [class]="selectedFolder && (selectedFolder.id === folder.folder.id) ? 'bi bi-folder2-open docs-icon me-1' : 'bi bi-folder2 docs-icon me-1'"
                               ngbTooltip="{{ 'USER_PROFILE.TEXT.DOC.FOLDER' | translate }}"
                            ></i>
                            <span (click)="selectFolder(folder.folder)"
                                  class="text-primary pointer">{{ folder.folder.name }}<br>
                                <small class="text-info">{{ folder.folder.updated_at | date:'HH:mm dd.MM.yyyy' }}</small>
                            </span>
                        </div>
                        <i (click)="openPermissionsTemplate(folder.folder, rightsModal, folder.rights)"
                           class="bi bi-gear-fill pointer"
                        ></i>
                    </div>

                    <div *ngIf="foldersSlider[folder.folder.id]">
                        <div *ngFor="let child of folder.children"
                             class="subdivision">
                            <ng-container
                                    *ngTemplateOutlet="folderItem; context: {folder: child}"></ng-container>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>

<ng-template #docModal
             let-modal>
    <app-button-modal-close [modalSize]="'xl'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="d-inline-block w-100">
            <app-component-doc-view (deleteEmit)="modal.close()"
                                    [fileUkey]="selectedFile.key"
                                    [isOpenModal]="true"
            ></app-component-doc-view>
        </div>
    </div>
</ng-template>

<ng-template #rightsModal
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2> {{ selectedPermissionsItem.name }}</h2>
        <div *ngIf="!selectedPermissionsItem.right['current']">
            <span *ngFor="let permission of permissions">
                <strong>{{ permission.title | translate }}: </strong>
                <i [class]="selectedPermissionsItem.right[permission.right] ? 'bi bi-check text-success' : 'bi bi-x text-danger'"></i>
                <br>
            </span>
        </div>
        <div *ngIf="selectedPermissionsItem.right['current']">
            <h2><i><u>{{ helper.fullName(profile) }}</u></i>:</h2>
            <span *ngFor="let permission of permissions">
                <strong>{{ permission.title }}: </strong>
                <i [class]="selectedPermissionsItem.right['find'][permission.right] ? 'bi bi-check text-success' : 'bi bi-x text-danger'"></i>
                <br>
            </span>
            <h2 class="mt-3"><i><u>{{ 'USER_PROFILE.TEXT.DOC.MY' | translate }}:</u></i></h2>
            <span *ngFor="let permission of permissions">
                <strong>{{ permission.title }}: </strong>
                <i [class]="selectedPermissionsItem.right['current'][permission.right] ? 'bi bi-check text-success' : 'bi bi-x text-danger'"></i>
                <br>
            </span>
        </div>
    </div>
</ng-template>
